import { TelematicsEnrollmentType } from './types';

export const transformTelematicsEnrollmentRequest = (
  data: TelematicsEnrollmentType
): any => {
  return {
    insuranceProducts: [
      {
        telematics: {
          enrolled: data.enrolled === 'true',
        },
        productType: 'personalAuto',
      },
    ],
  };
};
